import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M480-120q-151 0-255.5-46.5T120-280v-400q0-66 105.5-113T480-840t254.5 47T840-680v400q0 67-104.5 113.5T480-120m0-488q86 0 176.5-26.5T773-694q-27-32-117.5-59T480-780q-88 0-177 26t-117 60q28 35 116 60.5T480-608m-1 214q42 0 84-4.5t80.5-13.5 73.5-22 63-29v-155q-29 16-64 29t-74 22-80 14-83 5-84-5-80.5-14-73-22-61.5-29v155q27 16 61 29t72.5 22 80.5 13.5 85 4.5m1 214q48 0 99-8.5t93.5-22.5 72-31 35.5-35v-125q-28 16-63 28.5T643.5-352t-80 13.5T479-334t-85-4.5-80.5-13.5-72.5-21.5-61-28.5v126q5 17 34 34.5t72 31 94 22 100 8.5" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }